// client/src/hooks/useCollectionStyle.js
import { useUserPreferences } from '../contexts/UserPreferencesContext';

function buildBackgroundSx(bg) {
  if (!bg || bg.kind === 'none') return {};
  if (bg.kind === 'solid' && bg.color) {
    return { background: bg.color };
  }
  if (bg.kind === 'gradient' && bg.color) {
    const c2 = bg.color2 || bg.color;
    const angle = bg.angle ?? 135;
    return { background: `linear-gradient(${angle}deg, ${bg.color}, ${c2})` };
  }
  if (bg.kind === 'image' && bg.assetKey) {
    return {
      backgroundImage: `url(/uploads/${bg.assetKey})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  }
  return {};
}

/**
 * Returns sx objects for card and page backgrounds for a given collection key.
 * @param {string} collectionKey — e.g. 'games', 'movies'
 * @returns {{ cardSx: object, pageSx: object }}
 */
export function useCollectionStyle(collectionKey) {
  const { preferences } = useUserPreferences();
  const settings = preferences?.collectionSettings?.[collectionKey];
  return {
    cardSx: buildBackgroundSx(settings?.cardBackground),
    pageSx: buildBackgroundSx(settings?.pageBackground),
  };
}

export default useCollectionStyle;
